import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'

import welcome from './components/Welcome';
import details from './components/Details';
import results from './components/Results';
import disclaimer from './components/Disclaimer';

//import "tippy.js/themes/light.css";
import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

Vue.use(VueRouter)
Vue.use(Vuex)

Vue.use(VueAnalytics, {
  id: ['UA-121628632-6', 'UA-153995209-1']
})

const routes = [
  { 
    path: '/welcome',
    component: welcome,
    meta: {
      title: 'Welcome - CSC Benchmark'
    }
  },
  { 
    path: '/details',
    component: details,
    meta: {
      title: 'Your details - CSC Benchmark'
    }
  },
  { 
    path: '/results',
    component: results,
    meta: {
      title: 'Results - CSC Benchmark'
    }
  },
  { 
    path: '/disclaimer',
    component: disclaimer,
    meta: {
      title: 'Disclaimer and Assumptions - CSC Benchmark'
    }
  },
  {
    path: '/',
    redirect: '/welcome'
  },
  {
    path: '/assumptions',
    redirect: '/disclaimer'
  }
];

const router = new VueRouter({
  routes, // short for routes: routes
  //Go to top of page on route change 
  scrollBehavior () {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})


Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    age: undefined,
    gender: '',
    scheme: '',
    fundBalance: undefined,
    preTaxContributions: undefined,
    postTaxContributions: undefined,
    schemeList: [
      {text: 'ADF Super', value: 'ADFSuper'},
      {text: 'MilitarySuper', value: 'MSBS'},
      // {text: 'CSS', value: 'CSS'},
      {text: 'PSS', value: 'PSS'},
      {text: 'PSSap', value: 'PSSAP'}
    ],
    filter: 'AGE',
    filterList: [
      {text: 'age', value: 'AGE'},
      {text: 'gender', value: 'GENDER'},
      {text: 'age & gender', value: 'AGEGENDER'},
      {text: 'scheme', value: 'ALL'},
    ],
    switcher: 'BALANCE',
    switcherList: [
      {text: 'Balance', value: 'BALANCE'},
      {text: 'Pre-tax Contributions', value: 'PRETAX'},
      {text: 'Post-tax Contributions', value: 'POSTTAX'},
    ],
    postcode: '',
    postcodeList: [
      {text: 'Australian Capital Territory', value: 'ACT'},
      {text: 'New South Wales', value: 'NSW'},
      {text: 'Northern Territory', value: 'NT'},
      {text: 'Queensland', value: 'QLD'},
      {text: 'South Australia', value: 'SA'},
      {text: 'Tasmania', value: 'TAS'},
      {text: 'Victoria', value: 'VIC'},
      {text: 'Western Australia', value: 'WA'},
    ],
    averages: {

      "PSSAP": {
        dataSet: {
          'BALANCE': {
            all: 128935,
            age: {
              "under18": 1903,
              "18": 2169,
              "19": 4881,
              "20": 7351,
              "21": 9749,
              "22": 12591,
              "23": 14785,
              "24": 19300,
              "25": 24366,
              "26": 31314,
              "27": 38002,
              "28": 45291,
              "29": 53084,
              "30": 61086,
              "31": 72201,
              "32": 81644,
              "33": 95866,
              "34": 107567,
              "35": 118615,
              "36": 128358,
              "37": 141715,
              "38": 149883,
              "39": 153298,
              "40": 157832,
              "41": 157092,
              "42": 156437,
              "43": 160911,
              "44": 165616,
              "45": 161291,
              "46": 167919,
              "47": 168657,
              "48": 175064,
              "49": 169001,
              "50": 178458,
              "51": 178473,
              "52": 178602,
              "53": 189092,
              "54": 190428,
              "55": 176915,
              "56": 166923,
              "57": 175351,
              "58": 175799,
              "59": 186773,
              "60": 189465,
              "61": 185353,
              "62": 163370,
              "63": 165678,
              "64": 172885,
              "65": 144614,
              "over65": 127004
            },
            gender: {
              'F': 120247,
              'M': 141989
            },
            ageAndGender: {
              'F': {
                age: {
                  "under18": 1637,
                  "18": 2347,
                  "19": 5110,
                  "20": 7966,
                  "21": 10441,
                  "22": 13548,
                  "23": 15551,
                  "24": 19881,
                  "25": 25281,
                  "26": 31968,
                  "27": 39573,
                  "28": 47089,
                  "29": 55053,
                  "30": 61742,
                  "31": 73575,
                  "32": 81717,
                  "33": 96452,
                  "34": 108409,
                  "35": 118061,
                  "36": 125636,
                  "37": 135150,
                  "38": 144798,
                  "39": 147816,
                  "40": 149601,
                  "41": 148420,
                  "42": 145967,
                  "43": 149245,
                  "44": 150782,
                  "45": 147007,
                  "46": 153158,
                  "47": 150833,
                  "48": 156717,
                  "49": 152605,
                  "50": 158245,
                  "51": 157979,
                  "52": 155769,
                  "53": 164606,
                  "54": 168690,
                  "55": 164159,
                  "56": 142059,
                  "57": 148622,
                  "58": 152395,
                  "59": 167125,
                  "60": 174131,
                  "61": 162822,
                  "62": 148998,
                  "63": 154908,
                  "64": 162257,
                  "65": 133839,
                  "over65": 113308
                },
              },
              'M': {
                age: {
                  "under18": 2434,
                  "18": 1876,
                  "19": 4716,
                  "20": 6601,
                  "21": 8969,
                  "22": 11515,
                  "23": 13777,
                  "24": 18709,
                  "25": 23251,
                  "26": 30699,
                  "27": 36177,
                  "28": 43214,
                  "29": 50467,
                  "30": 60472,
                  "31": 70480,
                  "32": 82046,
                  "33": 95412,
                  "34": 106806,
                  "35": 120116,
                  "36": 133474,
                  "37": 152289,
                  "38": 158405,
                  "39": 162353,
                  "40": 170885,
                  "41": 170706,
                  "42": 171885,
                  "43": 178860,
                  "44": 186069,
                  "45": 180628,
                  "46": 189548,
                  "47": 192769,
                  "48": 202092,
                  "49": 192439,
                  "50": 206134,
                  "51": 207614,
                  "52": 210664,
                  "53": 222744,
                  "54": 219405,
                  "55": 196001,
                  "56": 201690,
                  "57": 210958,
                  "58": 208985,
                  "59": 212727,
                  "60": 209210,
                  "61": 215578,
                  "62": 182869,
                  "63": 180328,
                  "64": 185637,
                  "65": 156381,
                  "over65": 139541
                }
              }
            }
          },
          'PRETAX': {
            all: 6102,
            age: {
              "18": 6006,
              "19": 2896,
              "20": 3296,
              "21": 2186,
              "22": 2933,
              "23": 4108,
              "24": 5019,
              "25": 3935,
              "26": 4166,
              "27": 3669,
              "28": 4042,
              "29": 4301,
              "30": 3798,
              "31": 4468,
              "32": 4216,
              "33": 4300,
              "34": 4079,
              "35": 4175,
              "36": 4266,
              "37": 4437,
              "38": 4377,
              "39": 4090,
              "40": 4751,
              "41": 4939,
              "42": 4813,
              "43": 4645,
              "44": 4360,
              "45": 4854,
              "46": 5077,
              "47": 5588,
              "48": 5656,
              "49": 5509,
              "50": 6242,
              "51": 6069,
              "52": 6081,
              "53": 6997,
              "54": 6623,
              "55": 7358,
              "56": 7628,
              "57": 7451,
              "58": 7800,
              "59": 8297,
              "60": 8466,
              "61": 8389,
              "62": 8715,
              "63": 9346,
              "64": 8664,
              "65": 9245,
              "over65": 9303
            },
            gender: {
              'F': 5805,
              'M': 6522
            },
            ageAndGender: {
              'F': {
                age: {
                  "18": 6006,
                  "19": 1403,
                  "20": 3503,
                  "21": 2759,
                  "22": 2368,
                  "23": 3585,
                  "24": 3252,
                  "25": 3419,
                  "26": 3924,
                  "27": 3357,
                  "28": 3812,
                  "29": 3783,
                  "30": 3372,
                  "31": 3811,
                  "32": 3737,
                  "33": 3688,
                  "34": 3549,
                  "35": 3726,
                  "36": 3435,
                  "37": 4058,
                  "38": 3737,
                  "39": 3877,
                  "40": 4370,
                  "41": 4413,
                  "42": 4325,
                  "43": 4351,
                  "44": 4288,
                  "45": 4852,
                  "46": 4949,
                  "47": 5398,
                  "48": 5697,
                  "49": 5511,
                  "50": 6074,
                  "51": 6110,
                  "52": 5846,
                  "53": 7092,
                  "54": 6513,
                  "55": 7318,
                  "56": 7536,
                  "57": 7467,
                  "58": 7487,
                  "59": 8382,
                  "60": 8305,
                  "61": 8275,
                  "62": 8708,
                  "63": 9399,
                  "64": 8795,
                  "65": 9144,
                  "over65": 9023
                },
              },
              'M': {
                age: {
                  "19": 4390,
                  "20": 4037,
                  "21": 1613,
                  "22": 3840,
                  "23": 5040,
                  "24": 6933,
                  "25": 4791,
                  "26": 4513,
                  "27": 4133,
                  "28": 4559,
                  "29": 5121,
                  "30": 4286,
                  "31": 5610,
                  "32": 4947,
                  "33": 5203,
                  "34": 4963,
                  "35": 4961,
                  "36": 5604,
                  "37": 4993,
                  "38": 5361,
                  "39": 4459,
                  "40": 5411,
                  "41": 5542,
                  "42": 5425,
                  "43": 5033,
                  "44": 4432,
                  "45": 4857,
                  "46": 5240,
                  "47": 5908,
                  "48": 5626,
                  "49": 5564,
                  "50": 6507,
                  "51": 6005,
                  "52": 6435,
                  "53": 6903,
                  "54": 6761,
                  "55": 7372,
                  "56": 7727,
                  "57": 7427,
                  "58": 8206,
                  "59": 8195,
                  "60": 8651,
                  "61": 8487,
                  "62": 8743,
                  "63": 9318,
                  "64": 8480,
                  "65": 9360,
                  "over65": 9599
                }
              }
            }
          },
          'POSTTAX': {
            all: 10636,
            age: {
              "under18": 1000,
              "18": 460,
              "19": 1926,
              "20": 2630,
              "21": 2523,
              "22": 2644,
              "23": 1731,
              "24": 3052,
              "25": 2421,
              "26": 3060,
              "27": 2766,
              "28": 3591,
              "29": 2644,
              "30": 4170,
              "31": 3582,
              "32": 3370,
              "33": 3817,
              "34": 4762,
              "35": 3919,
              "36": 4566,
              "37": 4935,
              "38": 4076,
              "39": 5158,
              "40": 5528,
              "41": 4735,
              "42": 4247,
              "43": 5542,
              "44": 4920,
              "45": 5540,
              "46": 5471,
              "47": 6829,
              "48": 7139,
              "49": 5892,
              "50": 10326,
              "51": 6342,
              "52": 7074,
              "53": 11730,
              "54": 9489,
              "55": 10048,
              "56": 10961,
              "57": 15533,
              "58": 17028,
              "59": 21469,
              "60": 28704,
              "61": 30221,
              "62": 33090,
              "63": 24363,
              "64": 30741,
              "65": 30026,
              "over65": 26808
            },
            gender: {
              'F': 10629,
              'M': 10667
            },
            ageAndGender: {
              'F': {
                age: {
                  "18": 550,
                  "19": 1517,
                  "20": 637,
                  "21": 1397,
                  "22": 2925,
                  "23": 1586,
                  "24": 2954,
                  "25": 2075,
                  "26": 2719,
                  "27": 2544,
                  "28": 2552,
                  "29": 1904,
                  "30": 3172,
                  "31": 3322,
                  "32": 2973,
                  "33": 3481,
                  "34": 3513,
                  "35": 3749,
                  "36": 4832,
                  "37": 5157,
                  "38": 3144,
                  "39": 5526,
                  "40": 5963,
                  "41": 4581,
                  "42": 4501,
                  "43": 5363,
                  "44": 4486,
                  "45": 5620,
                  "46": 5539,
                  "47": 6877,
                  "48": 8453,
                  "49": 6209,
                  "50": 12505,
                  "51": 6525,
                  "52": 7754,
                  "53": 9859,
                  "54": 9450,
                  "55": 10144,
                  "56": 11424,
                  "57": 14392,
                  "58": 16159,
                  "59": 26010,
                  "60": 31462,
                  "61": 30677,
                  "62": 35967,
                  "63": 29296,
                  "64": 31236,
                  "65": 30716,
                  "over65": 28564
                },
              },
              'M': {
                age: {
                  "under18": 1000,
                  "18": 415,
                  "19": 2336,
                  "20": 4036,
                  "21": 3436,
                  "22": 2488,
                  "23": 1834,
                  "24": 3219,
                  "25": 2861,
                  "26": 3455,
                  "27": 3009,
                  "28": 5100,
                  "29": 3775,
                  "30": 5652,
                  "31": 4052,
                  "32": 4068,
                  "33": 4318,
                  "34": 7114,
                  "35": 4165,
                  "36": 4090,
                  "37": 4605,
                  "38": 5468,
                  "39": 4383,
                  "40": 3854,
                  "41": 5086,
                  "42": 3783,
                  "43": 5926,
                  "44": 5806,
                  "45": 5537,
                  "46": 5345,
                  "47": 6823,
                  "48": 5034,
                  "49": 5398,
                  "50": 7816,
                  "51": 6191,
                  "52": 6340,
                  "53": 14424,
                  "54": 9535,
                  "55": 10061,
                  "56": 9335,
                  "57": 16781,
                  "58": 18424,
                  "59": 14788,
                  "60": 25379,
                  "61": 29835,
                  "62": 29479,
                  "63": 18539,
                  "64": 30993,
                  "65": 29791,
                  "over65": 25232
                }
              }
            }
          }
        }
      },

      "PSS": {
        dataSet: {
          'BALANCE': {
            all: 292212,
            age: {
              "27": 6449,
              "29": 10806,
              "32": 5016,
              "33": 110342,
              "34": 105111,
              "35": 167958,
              "36": 176885,
              "37": 184332,
              "38": 187675,
              "39": 204228,
              "40": 217312,
              "41": 229229,
              "42": 236783,
              "43": 243950,
              "44": 248664,
              "45": 258445,
              "46": 264624,
              "47": 270011,
              "48": 270856,
              "49": 280141,
              "50": 289961,
              "51": 298736,
              "52": 308779,
              "53": 318266,
              "54": 328932,
              "55": 316642,
              "56": 327443,
              "57": 326257,
              "58": 329566,
              "59": 326567,
              "60": 311386,
              "61": 298155,
              "62": 315288,
              "63": 303557,
              "64": 298231,
              "65": 373374,
              "over65": 381913
            },
            gender: { 
              'F': 265465,
              'M': 332728
            }
          }
        }
      },

      "MSBS": {
        dataSet: {
          'BALANCE': {
            all: 135362,
            age: {
              "23": 41769,
              "24": 40924,
              "25": 46002,
              "26": 53649,
              "27": 56636,
              "28": 63714,
              "29": 68469,
              "30": 74966,
              "31": 81580,
              "32": 89333,
              "33": 97319,
              "34": 104726,
              "35": 111232,
              "36": 118472,
              "37": 125776,
              "38": 129423,
              "39": 134964,
              "40": 139433,
              "41": 143816,
              "42": 155331,
              "43": 158384,
              "44": 151016,
              "45": 156549,
              "46": 157346,
              "47": 153122,
              "48": 157409,
              "49": 168204,
              "50": 177229,
              "51": 180676,
              "52": 181338,
              "53": 187656,
              "54": 198013,
              "55": 201797,
              "56": 184101,
              "57": 179484,
              "58": 187984,
              "59": 192022,
              "60": 188019,
              "61": 170798,
              "62": 152663,
              "63": 171668,
              "64": 128705,
              "65": 136753,
              "over65": 78879
            },
            gender: { 
              'F': 126548,
              'M': 137194
            }
          }
        }
      },

      "ADFSuper": {
        dataSet: {
          'BALANCE': {
            all: 37641,
            age: {
              "under18": 2006,
              "18": 3543,
              "19": 8141,
              "20": 13957,
              "21": 20623,
              "22": 27880,
              "23": 34994,
              "24": 37668,
              "25": 38903,
              "26": 41553,
              "27": 43822,
              "28": 48788,
              "29": 52052,
              "30": 53401,
              "31": 59635,
              "32": 58506,
              "33": 64371,
              "34": 65075,
              "35": 63022,
              "36": 64958,
              "37": 64664,
              "38": 64888,
              "39": 69112,
              "40": 63582,
              "41": 65799,
              "42": 63477,
              "43": 83996,
              "44": 66908,
              "45": 71578,
              "46": 76977,
              "47": 72023,
              "48": 67392,
              "49": 75880,
              "50": 85529,
              "51": 83163,
              "52": 80070,
              "53": 90329,
              "54": 97448,
              "55": 101540,
              "56": 90050,
              "57": 122087,
              "58": 78401,
              "59": 80538,
              "60": 116696,
              "61": 89386,
              "62": 49313,
              "63": 66927,
              "64": 78478,
              "65": 87877,
              "over65": 72644
            },
            gender: {
              'F': 39167,
              'M': 37125
            },
            ageAndGender: {
              'F': {
                age: {
                  "under18": 1507,
                  "18": 3431,
                  "19": 8221,
                  "20": 14603,
                  "21": 21480,
                  "22": 28953,
                  "23": 37154,
                  "24": 39206,
                  "25": 39790,
                  "26": 43205,
                  "27": 47356,
                  "28": 51764,
                  "29": 57002,
                  "30": 52853,
                  "31": 63523,
                  "32": 57627,
                  "33": 64317,
                  "34": 64143,
                  "35": 69907,
                  "36": 78123,
                  "37": 55677,
                  "38": 59896,
                  "39": 69148,
                  "40": 68720,
                  "41": 69864,
                  "42": 80942,
                  "43": 109189,
                  "44": 89711,
                  "45": 92486,
                  "46": 81060,
                  "47": 67165,
                  "48": 75377,
                  "49": 68875,
                  "50": 90049,
                  "51": 94102,
                  "52": 70093,
                  "53": 109723,
                  "54": 100118,
                  "55": 117662,
                  "56": 86916,
                  "57": 90261,
                  "58": 81208,
                  "59": 42374,
                  "60": 7240,
                  "61": 37683,
                  "62": 18864,
                  "63": 68926,
                  "64": 6836,
                  "over65": 34769
                },
              },
              'M': {
                age: {
                  "under18": 2034,
                  "18": 3578,
                  "19": 8114,
                  "20": 13742,
                  "21": 20327,
                  "22": 27496,
                  "23": 34263,
                  "24": 37187,
                  "25": 38620,
                  "26": 40981,
                  "27": 42586,
                  "28": 47772,
                  "29": 50166,
                  "30": 53589,
                  "31": 58134,
                  "32": 58921,
                  "33": 64396,
                  "34": 65387,
                  "35": 60297,
                  "36": 60921,
                  "37": 67625,
                  "38": 67181,
                  "39": 69099,
                  "40": 61784,
                  "41": 64643,
                  "42": 55448,
                  "43": 76757,
                  "44": 59058,
                  "45": 66278,
                  "46": 74867,
                  "47": 73781,
                  "48": 64417,
                  "49": 77355,
                  "50": 83996,
                  "51": 78922,
                  "52": 81227,
                  "53": 83306,
                  "54": 96781,
                  "55": 97317,
                  "56": 90335,
                  "57": 128452,
                  "58": 77933,
                  "59": 91442,
                  "60": 125571,
                  "61": 92911,
                  "62": 54121,
                  "63": 66865,
                  "64": 84619,
                  "65": 87877,
                  "over65": 74916
                }
              }
            }
          },
          'PRETAX': {
            all: 5044,
            age: {
              "18": 300,
              "19": 2308,
              "20": 5024,
              "21": 2983,
              "22": 4739,
              "23": 3705,
              "24": 4298,
              "25": 3763,
              "26": 6806,
              "27": 4802,
              "28": 5879,
              "29": 4473,
              "30": 5997,
              "31": 8308,
              "32": 2551,
              "33": 6818,
              "34": 5429,
              "35": 7191,
              "36": 9298,
              "37": 1641,
              "38": 1075,
              "39": 3310,
              "40": 1762,
              "41": 2720,
              "42": 5535,
              "43": 4852,
              "44": 1520,
              "45": 2600,
              "46": 4366,
              "47": 1664,
              "48": 2460,
              "49": 2533,
              "50": 5461,
              "51": 6151,
              "52": 7243,
              "53": 3890,
              "54": 5953,
              "55": 4677,
              "56": 13542,
              "57": 4656,
              "58": 12889,
              "59": 10229,
              "60": 4233,
              "61": 9725,
              "62": 7167,
              "63": 18000,
              "64": 650,
              "65": 17062,
              "over65": 3000
            },
            gender: {
              'F': 4968,
              'M': 5076
            },
            ageAndGender: {
              'F': {
                age: {
                  "19": 1725,
                  "20": 10064,
                  "21": 3807,
                  "22": 5335,
                  "23": 3132,
                  "24": 3914,
                  "25": 4104,
                  "26": 4396,
                  "27": 3257,
                  "28": 7648,
                  "29": 4400,
                  "30": 6973,
                  "31": 8749,
                  "32": 1953,
                  "33": 7526,
                  "34": 2793,
                  "35": 6917,
                  "36": 8725,
                  "37": 1158,
                  "38": 1750,
                  "39": 1667,
                  "40": 260,
                  "41": 300,
                  "45": 2600,
                  "46": 3688,
                  "47": 2345,
                  "48": 2460,
                  "50": 1997,
                  "51": 5326,
                  "53": 5040,
                  "55": 1350,
                  "56": 4500,
                  "58": 19140,
                  "59": 11400,
                  "61": 8500,
                  "62": 8450,
                  "63": 18000
                },
              },
              'M': {
                age: {
                  "18": 300,
                  "19": 2775,
                  "20": 2504,
                  "21": 2679,
                  "22": 4479,
                  "23": 3801,
                  "24": 4403,
                  "25": 3627,
                  "26": 7940,
                  "27": 5785,
                  "28": 5062,
                  "29": 4523,
                  "30": 5578,
                  "31": 8071,
                  "32": 2850,
                  "33": 6229,
                  "34": 6182,
                  "35": 7397,
                  "36": 9412,
                  "37": 2246,
                  "38": 400,
                  "39": 5500,
                  "40": 2263,
                  "41": 3325,
                  "42": 5535,
                  "43": 4852,
                  "44": 1520,
                  "46": 5043,
                  "47": 1210,
                  "49": 2533,
                  "50": 6038,
                  "51": 7800,
                  "52": 7243,
                  "53": 3028,
                  "54": 5953,
                  "55": 5152,
                  "56": 15803,
                  "57": 4656,
                  "58": 10805,
                  "59": 9839,
                  "60": 4233,
                  "61": 10133,
                  "62": 6525,
                  "64": 650,
                  "65": 17062,
                  "over65": 3000
                }
              }
            }
          },
          'POSTTAX': {
            all: 1793,
            age: {
              "under18": 374,
              "18": 539,
              "19": 978,
              "20": 1225,
              "21": 1344,
              "22": 1578,
              "23": 1396,
              "24": 1301,
              "25": 1500,
              "26": 1929,
              "27": 1533,
              "28": 1443,
              "29": 1370,
              "30": 1397,
              "31": 1911,
              "32": 1623,
              "33": 1222,
              "34": 1509,
              "35": 1360,
              "36": 2284,
              "37": 594,
              "38": 1658,
              "39": 2233,
              "40": 3405,
              "41": 1699,
              "42": 1387,
              "43": 2386,
              "44": 1100,
              "45": 18370,
              "46": 12229,
              "47": 6576,
              "48": 3252,
              "49": 5269,
              "50": 1088,
              "51": 5938,
              "52": 3602,
              "53": 2622,
              "54": 2953,
              "55": 6046,
              "56": 7982,
              "57": 6609,
              "58": 4844,
              "59": 50359,
              "60": 10134,
              "61": 3007,
              "62": 15670,
              "63": 6800,
              "64": 6450,
              "65": 4050,
              "over65": 3824
            },
            gender: {
              'F': 1813,
              'M': 1786
            },
            ageAndGender: {
              'F': {
                age: {
                  "18": 449,
                  "19": 830,
                  "20": 1093,
                  "21": 1102,
                  "22": 1982,
                  "23": 1179,
                  "24": 1395,
                  "25": 2210,
                  "26": 2870,
                  "27": 1457,
                  "28": 1716,
                  "29": 963,
                  "30": 1625,
                  "31": 1685,
                  "32": 1045,
                  "33": 1134,
                  "34": 1435,
                  "35": 1274,
                  "36": 1614,
                  "37": 467,
                  "38": 1409,
                  "39": 2420,
                  "40": 2590,
                  "41": 1233,
                  "42": 1269,
                  "43": 2978,
                  "44": 1600,
                  "45": 500,
                  "46": 29895,
                  "47": 15050,
                  "49": 2850,
                  "50": 1173,
                  "51": 6875,
                  "53": 4375,
                  "54": 7500,
                  "55": 11250,
                  "56": 12500,
                  "57": 8000,
                  "59": 300,
                  "61": 2500,
                  "62": 16875,
                  "64": 900,
                  "over65": 3900
                }
              },
              'M': {
                age: {
                  "under18": 374,
                  "18": 563,
                  "19": 1031,
                  "20": 1258,
                  "21": 1420,
                  "22": 1440,
                  "23": 1473,
                  "24": 1269,
                  "25": 1305,
                  "26": 1555,
                  "27": 1564,
                  "28": 1331,
                  "29": 1554,
                  "30": 1273,
                  "31": 2033,
                  "32": 2161,
                  "33": 1258,
                  "34": 1552,
                  "35": 1400,
                  "36": 2605,
                  "37": 668,
                  "38": 1879,
                  "39": 2114,
                  "40": 3745,
                  "41": 2026,
                  "42": 1434,
                  "43": 1903,
                  "44": 475,
                  "45": 22837,
                  "46": 1630,
                  "47": 2338,
                  "48": 3252,
                  "49": 5614,
                  "50": 1045,
                  "51": 5000,
                  "52": 3602,
                  "53": 1746,
                  "54": 1437,
                  "55": 5005,
                  "56": 7531,
                  "57": 6377,
                  "58": 4844,
                  "59": 57510,
                  "60": 10134,
                  "61": 3092,
                  "62": 15269,
                  "63": 6800,
                  "64": 7243,
                  "65": 4050,
                  "over65": 3809
                }
              }
            }
          }
        }
      }
    }
  },

  getters: {
    getAge(state) {
      return state.age;
    },
    getGender(state) {
      return state.gender;
    },
    getFundBalance(state) {
      return state.fundBalance;
    },
    getPreTaxContributions(state) {
      return state.preTaxContributions;
    },
    getPostTaxContributions(state) {
      return state.postTaxContributions;
    },
    getScheme(state) {
      return state.scheme;
    },
    getSchemeList(state) {
      return state.schemeList;
    },
    getFilter(state) {
      return state.filter;
    },
    getFilterList(state) {
      return state.filterList;
    },
    getSwitcher(state) {
      return state.switcher;
    },
    getSwitcherList(state) {
      return state.switcherList;
    },
    getPostcode(state) {
      return state.postcode;
    },
    getPostcodeList(state) {
      return state.postcodeList;
    },
    getAverages(state) {
      return state.averages;
    },
  },
  
  mutations: {
    setAge(state, target) {
      state.age = target;
    },
    setGender(state, target) {
      state.gender = target;
    },
    setFundBalance(state, target) {
      state.fundBalance = target;
    },
    setPreTaxContributions(state, target) {
      state.preTaxContributions = target;
    },
    setPostTaxContributions(state, target) {
      state.postTaxContributions = target;
    },
    setScheme(state, target) {
      state.scheme = target;
    },
    setFilter(state, target) {
      state.filter = target;
    },
    setSwitcher(state, target) {
      state.switcher = target;
    },
    setPostcode(state, target) {
      state.postcode = target;
    },
  }
})

new Vue({
	router,
	store,
  // watch: {
  //   $route: function(to) {
  //     this.$nextTick(function () {
  //     // $nextTick = DOM updated
    
  //   // Change document title
  //     document.title = to.meta.title;
    
  //       setTimeout(function() {

  //         // Get component's "routeFocusTarget" ref. 
  //         // If not existent, use router view container
  //         /* eslint-disable no-console */
  //         console.log(this.$refs.routerView.$refs.componentFocusTarget);
  //         /* eslint-enable no-console */

  //         let focusTarget = (this.$refs.routerView.$refs.componentFocusTarget !== undefined) 
  //         ? this.$refs.routerView.$refs.componentFocusTarget
  //         : this.$refs.routerView.$el;

  //         // Make focustarget programmatically focussable
  //         focusTarget.setAttribute('tabindex', '-1');

  //         // Focus element
  //         focusTarget.focus();
  //         alert("ROUTE");

  //         // Remove tabindex from focustarget. 
  //         // Reason: https://axesslab.com/skip-links/#update-3-a-comment-from-gov-uk
  //         focusTarget.removeAttribute('tabindex');
  //       }, 0);
  //     });
  //   }
  // },
  render: h => h(App),
}).$mount('#app')
